import { render, staticRenderFns } from "./Form9.vue?vue&type=template&id=585b2f82&scoped=true"
import script from "./Form9.vue?vue&type=script&lang=ts"
export * from "./Form9.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=585b2f82&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b2f82",
  null
  
)

export default component.exports